import React from "react";
import Items from "./Items";
import { useSelector } from "react-redux";
const TopSelling = () => {
  const table_data = useSelector((state) => state.messageDetail);

  if (!table_data.table_data) return null;
  const joinedData = [
    ...table_data.table_data.dish,
    ...table_data.table_data.goods,
  ];
  return (
    <div className="sale_item_body">
      <h3 className="header_title">Top Selling Items</h3>
      <div className="sale_item_container">
        <ul className="sale_item_list">
          {joinedData.map((data) => {
            const { sold, _id, pieces } = data;

            return (
              <React.Fragment key={_id}>
                {sold >= pieces && <Items data={data} />}
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default TopSelling;
